<script lang="ts" setup>
import { onBeforeMount, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { useNotificationsStore } from '@/store/notifications'
import { usePayrollStore } from '@/store/payroll-data'
import { getErrorCode } from '@/app/core/composable/general'
import { DBtn, DLoading } from 'front-library'

import { getMasterConceptGroup } from '@/app/core/services/master-concept-groups'

const route = useRoute()
const router = useRouter()
const notifications = useNotificationsStore()
const payrollStore = usePayrollStore()
const { t } = useI18n()

const loading = ref(false)
const model = ref<any>({})

const back = () => {
  void router.push({ name: 'ListMasterConceptGroups' })
}

const getEntity = async () => {
  loading.value = true

  try {
    if (!route.params.id) return

    const data = await getMasterConceptGroup(route.params.id as string)
    if (!data) {
      notifications.addNotification({
        title: t('notification.notFound'),
        text: 'Master concept group not found',
        type: 'error',
        time: 10000
      })
      back()
      return
    }

    model.value = data
  } catch (error: any) {
    const code = getErrorCode(error.response?.data?.code)
    notifications.addNotification({
      title: t('error.titles.' + code),
      text: t('error.messages.' + code),
      type: 'error',
      time: 10000
    })
  } finally {
    loading.value = false
  }
}

onBeforeMount(async () => {
  await getEntity()
})
</script>

<template>
  <DLoading v-show="loading" :message="$t('loading.data')" />

  <div class="h-full px-5">
    <div class="bg-gray-50 pb-4">
      <div class="leading-4 pt-responsive">
        <p class="text-3xl font-semibold text-shadow text-blue-900">
          Master Concept Group Details
        </p>
      </div>
    </div>

    <div
      class="bg-white rounded-md shadow-md p-6 grid grid-cols-1 md:grid-cols-2 gap-4">
      <div>
        <p class="text-xs text-gray-500 uppercase">Code</p>
        <p class="text-base text-gray-900 font-medium">{{ model.code }}</p>
      </div>

      <div>
        <p class="text-xs text-gray-500 uppercase">Country</p>
        <p class="text-base text-gray-900 font-medium">
          {{ payrollStore.payroll?.country?.name }}
        </p>
      </div>

      <div class="md:col-span-2">
        <p class="text-xs text-gray-500 uppercase">Description</p>
        <p class="text-base text-gray-900 font-medium">
          {{ model.description }}
        </p>
      </div>
    </div>

    <div class="flex justify-end mt-4">
      <DBtn color="secondary" @click="back">{{ t('form.button.back') }}</DBtn>
    </div>
  </div>
</template>
